import { InjectionToken, Signal } from '@angular/core'
import { BadgeColors, Icon } from '@ftr/foundation'

export interface PortalBranding {
  badge: {
    icon: Icon
    color: BadgeColors
  }
  loginTitle: string
  loginSubTitle: string
  signupSubTitle: string
}

export const PUBLIC_PORTAL_BRANDING: PortalBranding = {
  badge: {
    icon: 'PeopleLine',
    color: BadgeColors.Blueberry,
  },
  loginTitle: 'Log in to Public Portal',
  loginSubTitle: 'Request court recordings or transcripts.',
  signupSubTitle: 'Create an account to request court recordings or transcripts.',
}

export const COURTS_PORTAL_BRANDING: PortalBranding = {
  badge: {
    icon: 'Courthouse',
    color: BadgeColors.Mint,
  },
  loginTitle: 'Log in to Court Portal',
  loginSubTitle: 'Access and manage court content.',
  signupSubTitle: 'Create an account to access and manage court content.',
}

/**
 * The branding of the portal the app is serving, if any. Undefined when the app has no
 * portal identity, in which case consumers fall back to generic For The Record copy.
 */
export const PORTAL_BRANDING = new InjectionToken<Signal<PortalBranding | undefined>>('PORTAL_BRANDING')
